/**
 * The API origin, for the handful of callers that must not pull in axios.
 *
 * `src/utils/api.ts` is the real client — interceptors, token refresh, the
 * confirm gate — and everything inside the signed-in app should use it. But it
 * imports axios, the Redux store and the toast layer, so importing it costs
 * about 24 KB of gzipped JavaScript before anything is on screen.
 *
 * That is a fine price for the app and a bad one for a marketing page, which
 * makes at most one unauthenticated GET and needs none of the machinery. Those
 * callers use plain `fetch` against this constant instead.
 *
 * The same literal is also inlined in the Server Components that build the OG
 * cards, the manifest and the icons; those run on the server, where bundle size
 * is not the question, and are deliberately left alone.
 */
export const API_BASE = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080/api';
